import React  , { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import {  FormControl, FormControlLabel, Checkbox,  Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function ModalEmpresaLaboral(props) {
    const [bodyModal, setBodyModal] = useState({ id: '', currencyJob: 'NO', companyName: '', occupation: '', workingStart: new Date(), yearsWorking: '', fisicos:false, quimicos:false, biologicos:false, ergonomicos:false, psicosociales:false})
    const handleChangeModal = e => {
        setBodyModal({
          ...bodyModal,
          [e.target.name]: e.target.value
      })
    }

    const handleChangeDate = (newValue) => {
      setBodyModal({
          ...bodyModal,
          ["workingStart"]: newValue
      })
  };

  const handleCheck = e => {

    setBodyModal({
      ...bodyModal,
      [e.target.name]: e.target.checked
  })
}

    const onSubmit = (props) => {

      if(bodyModal.companyName != '') {
          props.addEmpresa(bodyModal);
      }
	 }


    
  
  return (
    <div>
      <Modal
        open={true}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <form>
                <Grid container spacing={2} > 
                    
                    <Grid item xs={12} sm={12} md={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>EMPRESA</Typography>
                        <TextField
                            id='companyName'
                            name='companyName'
                            value={bodyModal.companyName}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                      
                   
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>CARGO</Typography>
                        <TextField
                            id='occupation'
                            name='occupation'
                            value={bodyModal.occupation}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                      
                   
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                    
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                id='workingStart'
                                name='workingStart'
                                label="FECHA DE INGRESO"
                                inputFormat="MM/dd/yyyy"
                                value={bodyModal.workingStart}
                                onChange={handleChangeDate}
                                
                                renderInput={(params) => <TextField {...params} fullWidth/>}
                            />
                        </LocalizationProvider>
                       
                    
                    </Grid>

                    <Grid item xs={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>ANTIGÜEDAD</Typography>
                        <TextField
                            id='yearsWorking'
                            name='yearsWorking'
                            value={bodyModal.yearsWorking}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                      
                   
                    </Grid>

                    <Grid item xs={12} >
                
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>FACTORES DE RIESGO</Typography>
                    <FormControlLabel  label="Físicos"  control={
                            <Checkbox 
                                name="fisicos"
                                id='fisicos'
                                checked={bodyModal.fisicos}
                                onChange={handleCheck}
                            />
                            } />
                 
<FormControlLabel  label="Químicos"  control={
                            <Checkbox 
                                name="quimicos"
                                id='quimicos'
                                checked={bodyModal.quimicos}
                                onChange={handleCheck}
                            />
                            } />
                            <FormControlLabel  label="Biológicos"  control={
                            <Checkbox 
                                name="biologicos"
                                id='biologicos'
                                checked={bodyModal.biologicos}
                                onChange={handleCheck}
                            />
                            } />

<FormControlLabel  label="Ergonómicos"  control={
                            <Checkbox 
                                name="ergonomicos"
                                id='ergonomicos'
                                checked={bodyModal.ergonomicos}
                                onChange={handleCheck}
                            />
                            } />

<FormControlLabel  label="Psicosociales"  control={
                            <Checkbox 
                                name="psicosociales"
                                id='psicosociales'
                                checked={bodyModal.psicosociales}
                                onChange={handleCheck}
                            />
                            } />
                      
                       
                    </Grid>

                    <Grid item xs={12} >
                      <div>
                    <FormControl fullWidth>
                            <InputLabel id="currencyJobLabel">ES El ACTUAL TRABAJO?</InputLabel>
                                <Select
                                    labelId="currencyJobLabel"
                                    id="currencyJob"
                                    name="currencyJob"
                                    value={bodyModal.currencyJob}
                                    onChange={handleChangeModal}
                                    label="TRABAJO ACTUAL">
                                      
                                    <MenuItem value={"NO"}>NO</MenuItem>
                                    <MenuItem value={"SI"}>SI</MenuItem>
                                   
                                </Select>
                            
                                </FormControl>
                                </div>
                    </Grid>

                    <Grid item xs={12} sm={6} >
                
                      <Button 
                      variant="contained" 
                      color="primary" 
                      display="inline" 
                      onClick={() => onSubmit(props)}
                      >
                          Guardar
                      </Button>

                     
                  </Grid>

                    </Grid>
                 </form>
        </Box>
      </Modal>
    </div>
  );
}